const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAgroIconBrown14(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 53.24 44.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "4.2 18.8 0 31.72 12.46 26.33 16.66 13.42 4.2 18.8",
    style: {
      fill: "#a26128"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "33.5 0 23.41 9.08 36.9 10.65 46.98 1.57 33.5 0",
    style: {
      fill: "#a26128"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.23,13.4l-4.31,13.25,11.91,10.84,3.25-9.98-2.09-.24c-.29-.04-.54-.23-.63-.52l-2.7-8.46c-.07-.04-.14-.08-.2-.13l-5.23-4.77Z",
    style: {
      fill: "#a26128"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "22.75 10.51 27.64 25.85 41.47 27.46 36.58 12.11 22.75 10.51",
    style: {
      fill: "#a26128"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: ".14 33.29 12.05 44.12 24.83 38.59 12.92 27.75 .14 33.29",
    style: {
      fill: "#a26128"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "48.35 2.34 38 11.66 42.89 27 53.24 17.68 48.35 2.34",
    style: {
      fill: "#a26128"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgroIconBrown14);
export default __webpack_public_path__ + "static/media/agro-icon-brown-14.ea0c90f7d17e1b45c2ec44d386ba986f.svg";
export { ForwardRef as ReactComponent };